import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Manager, Reference, Popper } from 'react-popper';
import Typography from '../../Styles/Typography/Typography';
const ReferenceContainer = styled.div `
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  color: blue;
`;
const TooltipContainer = styled.div `
  position: relative;
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  border-radius: ${props => props.theme.borders.borderRadius};
  padding: ${props => props.theme.paddingsMargins.themeMenuPadding};
  background-color: ${(props) => props.theme.utils.getColor(props.color)};
`;
const Tooltip = ({ children, color = 'main', position = 'bottom', text = 'tooltip', isOpen = false }) => {
    const [showMenu, setShowMenu] = useState(false);
    const onOpenMenu = () => {
        setShowMenu(true);
    };
    const onCloseMenu = () => {
        setShowMenu(false);
    };
    useEffect(() => {
        setShowMenu(isOpen === showMenu ? !showMenu : isOpen);
    }, [isOpen]);
    useEffect(() => {
        setShowMenu(isOpen);
    }, []);
    return (_jsxs(Manager, { children: [_jsx(Reference, { children: ({ ref }) => (_jsx(ReferenceContainer, Object.assign({ ref: ref, onMouseLeave: () => onCloseMenu(), onMouseEnter: () => onOpenMenu() }, { children: children }))) }), _jsx(Popper, Object.assign({ placement: position, modifiers: [{ name: 'preventOverflow' }] }, { children: ({ ref, style, placement }) => showMenu && (_jsx(TooltipContainer, Object.assign({ color: color, ref: ref, style: style, "data-placement": placement }, { children: _jsx(Typography, Object.assign({ size: "note", color: "#ffffff" }, { children: text })) }))) }))] }));
};
export default Tooltip;
